import script from "./AddPermissionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPermissionForm.vue?vue&type=script&setup=true&lang=js"

import "./AddPermissionForm.vue?vue&type=style&index=0&id=e10a884e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e10a884e"]])

export default __exports__